import { APP_NAME, APP_VERSION, TRADEMARK_DISCLAIMER } from './productMeta';

export default function LegalDisclaimer({ compact = false }) {
  if (compact) {
    return (
      <p className="text-[10px] leading-relaxed text-slate-500">
        {APP_NAME} v{APP_VERSION}. {TRADEMARK_DISCLAIMER}
      </p>
    );
  }

  return (
    <div className="legal-panel">
      <p className="font-medium text-slate-300">
        {APP_NAME} v{APP_VERSION}
      </p>
      <p className="mt-1">{TRADEMARK_DISCLAIMER}</p>
    </div>
  );
}
